<template>
    <div>
        <van-popup v-model="editSend" :closeable="true" position="bottom" round :style="{ height: '420px' }">
            <div class="title">修改文案</div>
            <div class="edit-send">
                <div class="edit-cont">
                    <div class="notice-bar">
                        <img class="notice-icon"
                            src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/reminder-icon.png"
                            alt="">
                        <div class="notice-cont">可对话术进行修改，「发送」后不会影响原有话术</div>
                    </div>
                    <div>
                        <div class="speech-cont">
                            <van-field v-model="msg" rows="4" type="textarea" maxlength="1300" placeholder="请输入内容"
                                show-word-limit />
                        </div>
                    </div>
                    <div class="foot-row">
                        <!--            <van-button class="foot-btn">保存话术</van-button>-->
                        <div @click="sendMessage" type="primary" class="foot-btn" block>发送话术</div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Divider, Toast } from 'vant'
import { sendChatMessage } from '@/utils/wxCodeAuth'
export default {
    components: {
        Divider, Toast
    },
    created() {
        // this.$emit('closeChange', false)
    },
    data() {
        return {
            editSend: false,
            msg: '',
            share: {
                type: '',
                contentData: ''
            }
        }
    },
    methods: {
        show() {
            this.editSend = true
        },
        msgs(msg) {
            this.msg = msg
        },
        sendMessage(item) {
            this.share.type = 1
            this.share.contentData = this.msg
            sendChatMessage(this.share.type, this.share.contentData).then(res => {
            })
        }
    }
}
</script>

<style scoped lang="less">
.title {
    color: #35434c;
    font-size: 34px;
    font-weight: 700;
    margin: 50px 30px 30px 30px;
}
.edit-send {
    .edit-cont {
        padding: 0 30px;
    }
    .notice-bar {
        padding: 18px 20px;
        display: flex;
        align-items: center;
        width: 690px;
        height: 70px;
        background: #e9f2ff;
        border-radius: 6px;
        color: #66757f;
        font-size: 24px;
    }
    .notice-icon {
        width: 24px;
        height: 30px;
        color: #fe8a37;
        margin-right: 10px;
    }

    .foot-row {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
    .foot-btn {
        width: 630px;
        height: 88px;
        background: #2fd0d5;
        border-radius: 44px;
        font-size: 32px;
        font-weight: 400;
        color: #ffffff;
        line-height: 88px;
        letter-spacing: 1px;
        text-align: center;
    }
    .speech-cont {
        margin-top: 20px;
        :deep(.van-field) {
            width: 690px;
            height: 300px;
            padding: 30px 20px;
            background: #f3f5f6;
            border-radius: 16px;
            position: relative;
        }
        :deep(.van-field__value) {
            overflow: auto;
        }
    }
    .clean-divider {
        margin: 25px 0 25px 0;
    }
}
</style>
